type MarqueeMeasurement = {
  /** Width of one copy of the track content. */
  copyWidth: number;
  /** Width of the visible area the track scrolls inside. */
  containerWidth: number;
  /** Left edge of one copy to the left edge of the next: copy width plus the
   *  track's gap. Equal to `copyWidth` while only one copy is rendered. */
  stride: number;
  /** Scroll speed in pixels per second. */
  speed: number;
};

export type MarqueeLayout = {
  /** One copy of the content fits the container, so there is nothing to scroll. */
  fits: boolean;
  /** Length of one loop, in seconds. */
  duration: number;
  /** Copies needed to keep the track filled across the loop seam. */
  numCopies: number;
};

/** Derives the marquee's layout from measured geometry. Returns `null` when the
 *  inputs aren't usable yet — an unlaid-out or hidden track measures zero, and
 *  overwriting good state with that would stall the animation. */
export function computeMarqueeLayout({
  copyWidth,
  containerWidth,
  stride,
  speed,
}: MarqueeMeasurement): MarqueeLayout | null {
  if (copyWidth <= 0 || containerWidth <= 0 || stride <= 0 || speed <= 0) {
    return null;
  }

  return {
    fits: copyWidth <= containerWidth,
    duration: stride / speed,
    numCopies: Math.ceil(containerWidth / stride) + 2,
  };
}
